module.exports = __webpack_public_path__ + "static/media/details-17-image-1.1ee04337.jpg";